module.exports = __webpack_public_path__ + "img/bs.4939a98b.svg";